import { ApiResourceBaseClass as e } from "./baseApiCalls.js";
const a = "review_analysis";
class g extends e {
  /**
   * Create review analysis settings.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/review_analysis/settings`
   *
   * @param {ReviewAnalysisSettingsPayload} payload
   * @returns {Promise<ReviewAnalysisSettingsResponse>} A promise resolving to the created settings.
   */
  async createSettings(t) {
    const { data: s } = await this.post(
      `${a}/settings`,
      t
    );
    return s;
  }
  /**
   * Update review analysis settings.
   *
   * HTTP Verb: `PUT`
   * Endpoint URL: `/review_analysis/settings/:id`
   *
   * @param {string} id
   * @param {ReviewAnalysisSettingsPayload} payload
   * @returns {Promise<ReviewAnalysisSettingsResponse>} A promise resolving to the updated settings.
   */
  async updateSettings(t, s) {
    const { data: n } = await this.put(
      `${a}/settings/${t}`,
      s
    );
    return n;
  }
  /**
   * Get the list of review analysis settings.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/review_analysis/settings`
   *
   * @returns {Promise<PaginatedReviewAnalysisSettingsResponse>} A promise resolving the list of settings.
   */
  async getSettings() {
    const { data: t } = await this.get(
      `${a}/settings`
    );
    return t;
  }
  /**
   * Get a specific review analysis setting by ID.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/review_analysis/settings/:id`
   *
   * @param {string} id - The ID of the review analysis setting.
   * @returns {Promise<ReviewAnalysisSettings>} A promise resolving the specific setting.
   */
  async getSettingById(t) {
    const { data: s } = await this.get(
      `${a}/settings/${t}`
    );
    return s;
  }
  /**
   * Get the list of org review analysis for the current user's org.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/review_analysis/org`
   *
   * @returns {Promise<OrgReviewAnalysisListResponse>} A promise resolving the org analysis list.
   */
  async getOrgAnalysisList() {
    const { data: t } = await this.get(`${a}/org`);
    return t;
  }
  /**
   * Get the org review analysis by id.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/review_analysis/org/:id`
   *
   * @returns {Promise<GlobalReviewAnalysis>} A promise resolving the org analysis.
   */
  async getOrgAnalysis(t) {
    const { data: s } = await this.get(`${a}/org/${t}`);
    return s;
  }
  /**
   * Get the list of group review analysis.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/review_analysis/org`
   *
   * @param {string} groups Filter the analysis list by group ids (comma-separated string)
   * @returns {Promise<GroupReviewAnalysisListResponse>} A promise resolving the group analysis list.
   */
  async getGroupAnalysisList(t) {
    const { data: s } = await this.get(`${a}/group`, {
      groups: t
    });
    return s;
  }
  /**
   * Get the group review analysis by id.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/review_analysis/org/:id`
   *
   * @returns {Promise<GlobalReviewAnalysis>} A promise resolving the group analysis.
   */
  async getGroupAnalysis(t) {
    const { data: s } = await this.get(`${a}/group/${t}`);
    return s;
  }
  /**
   * Get the list of business review analysis.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/review_analysis/business`
   *
   * @param {string} businessIds Filter the analysis list by business ids (comma-separated string)
   * @returns {Promise<BusinessReviewAnalysisListResponse>} A promise resolving the business analysis list.
   */
  async getBusinessAnalysisList(t) {
    const { data: s } = await this.get(
      `${a}/business`,
      { business__in: t }
    );
    return s;
  }
  /**
   * Get the business review analysis by id.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/review_analysis/business/:id`
   *
   * @returns {Promise<BusinessReviewAnalysis>} A promise resolving the business analysis.
   */
  async getBusinessAnalysis(t) {
    const { data: s } = await this.get(`${a}/business/${t}`);
    return s;
  }
}
export {
  g as ReviewAnalysis
};
